import React from "react";
import { mockups } from "../../data/mockups";
import { MockupShape } from "./MockupShape";
import { DesignLayer } from "./DesignLayer";
import type { DesignElement, MarkingId, MockupId, MockupView } from "../../types/configurator";
interface ProductPreviewProps {
  mockupId: MockupId;
  hex: string;
  view?: MockupView;
  elements?: DesignElement[];
  markingId?: MarkingId | null;
  className?: string;
}

/** Read-only live rendering of a product with its design. Always square. */
export function ProductPreview({
  mockupId,
  hex,
  view = "front",
  elements = [],
  markingId = null,
  className = ""
}: ProductPreviewProps) {
  const mockup = mockups.find(m => m.id === mockupId);
  if (!mockup) return null;
  return <div className={`relative aspect-square bg-mist ${className}`} data-id="element-95" data-mp="16bwfqfbxsmi9">
      <div className="absolute inset-[6%]" data-id="element-96" data-mp="2mqfugy54ykfb">
        <div className="absolute inset-0" data-id="element-97" data-mp="2mpea2328clkx">
          <MockupShape mockup={mockupId} view={view} hex={hex} data-id="element-98" data-mp="2hs4k8maxi7wk" />
        </div>
        <DesignLayer mockup={mockup} view={view} elements={elements} markingId={markingId} productHex={hex} data-id="element-99" data-mp="2hu78b0sitqyn" />
      </div>
    </div>;
}